/**
 * Aqui é onde deverá estar todos os serviços referentes a cadastro.
 */
import axios from 'axios';

// Define a URL base da API dinamicamente
const BASE_API =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000/api' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br/api'; // URL para ambiente de produção

const BASE_URL =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br'; // URL para ambiente de produção

sessionStorage.setItem('BASE_URL', JSON.stringify(BASE_URL)); // Armazenando todos os dados

console.log('Base API:', BASE_API); // Apenas para conferir qual URL está sendo usada

// Configura uma instância do Axios com opções padrão
const api = axios.create({
    baseURL: BASE_API,
    timeout: 10000, // 10 segundos de timeout
    headers: {
        'Content-Type': 'application/json',
    },
});
  
  
 
// Função para buscar pontos de mototaxi do representante comercial
export const buscarPontosDeMototaxiByRepresentante = async (dados) => {
  console.log('Entrou no buscarPontosDeMototaxiByRepresentante do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/representante/buscarPontosDeMototaxiByRepresentante';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar os serviços atendidos pelo mototaxi
export const buscarServicosAtendidosByPontoMototaxi = async (dados) => {
  console.log('Entrou no buscarServicosAtendidosByPontoMototaxi do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/ponto/buscarServicosAtendidosByPontoMototaxi';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar as localidades atendidas pelo mototáxi
export const buscarLocalidadesAtendidasByPontoMototaxi = async (dados) => {
  console.log('Entrou no buscarLocalidadesAtendidasByPontoMototaxi do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/ponto/buscarLocalidadesAtendidasByPontoMototaxi';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

 
// Função para buscar pilotos de mototaxi do ponto
export const buscarPilotosDeMototaxiByPonto = async (dados) => {
  console.log('Entrou no buscarPilotosDeMototaxiByPonto do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/ponto/buscarPilotosDeMototaxiByPonto';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

 
// Função para buscar dados de um determinado piloto - PELO PILOTO
// aqui também é verificado se existe viagem solicitada para este piloto
export const buscarDadosPiloto = async (dados) => {
  console.log(' 2 - Entrou no buscarDadosPiloto do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/piloto/buscarDadosPiloto';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    console.log('response.data.dadosPiloto: ');
    console.log(response.data.dadosPiloto);

    console.log('response.data.dadosPiloto.objViagem: ');
    console.log(response.data.dadosPiloto.objViagem);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar dados da viagem PELO PILOTO
export const buscarDadosViagem = async (dados) => {

    console.log('---------------');
    console.log('Entrou em buscarDadosViagem do listagemServico.js....');

    const payload = {
      ...dados,
    //   novoStatus
    };
  
    console.log('payload (*): ');
    console.log(payload);
  
    const endpoint = '/viagem/buscarDadosViagem';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });
  
    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }
  
    return await resposta.json();
  };
  

// Função para buscar dados da viagem PELO CLIENTE
export const buscarDadosViagemPeloCliente = async (dados) => {

    console.log('---------------');
    console.log('Entrou em buscarDadosViagemPeloCliente do listagemServico.js....');

    const payload = {
      ...dados,
    //   novoStatus
    };
  
    console.log('payload: ');
    console.log(payload);
  
    const endpoint = '/viagem/buscarDadosViagemPeloCliente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });
  
    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }
  
    return await resposta.json();
  };
  



// Função para buscar dados de um determinado piloto
export const buscarLocalizacaoPiloto = async (dados) => {
  console.log('Entrou no buscarLocalizacaoPiloto do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/piloto/buscarLocalizacaoPiloto';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

 
// Função para buscar dados de um determinado piloto
export const buscarPilotoById = async (dados) => {
  console.log('Entrou no buscarPilotoById do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/piloto/buscarPilotoById';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};


// Função para buscar pontos de mototaxi do representante comercial
export const buscarPontosDeMototaxiProximos = async (dados) => {
  console.log('Entrou no buscarPontosDeMototaxiProximos do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/representante/buscarPontosDeMototaxiProximos';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};


// Função para buscar pontos de mototaxi do representante comercial
export const buscarTodosPontosDeMototaxi = async (dados) => {
  console.log('Entrou no buscarTodosPontosDeMototaxi do listagemServico.js...');

  console.log('Dados enviados:', dados);

  const endpoint = '/ponto/buscarTodosPontosDeMototaxi';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};


// Função para buscar dados do ponto de mototaxi pelo id
export const buscarDadosPontoById = async (id, dadosCookies) => {
  console.log('Entrou no buscarDadosPontoById do listagemServico.js...');

  const payload = {
    ...dadosCookies,
    ponto_id: id
  };


  console.log('Dados que serão enviados:', payload);

  const endpoint = '/ponto/buscarDadosPontoById';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, payload);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar dados:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};
